export default "__VITE_ASSET__Br9U9xFS__";